import type { Meta } from '../db/tipos'
import { formatarMoeda } from '../lib/formatos'

// Morava em paginas/metas/Metas.tsx, que exportava a constante enquanto o
// Painel importava DA TELA -- era a causa do aviso react(only-export-components).
export const ROTULOS_TIPO_META: Record<Meta['tipo'], string> = {
  valor_vendido: 'Valor vendido (R$)',
  positivacao: 'Clientes positivados',
  itens_por_pedido: 'Itens por pedido',
  cobertura_linhas: 'Cobertura de linhas (%)',
  comissao_necessaria: 'Comissão necessária (R$)',
  faturamento_total: 'Faturamento total (R$)',
}

// Tres dos seis tipos guardam DINHEIRO. Escrito como lista, e nao como
// "todos menos os outros tres": tipo novo entra sem R$ por padrao, que erra
// para menos -- um numero sem simbolo confunde; um "R$" na frente de uma
// contagem de clientes mente.
const TIPOS_EM_DINHEIRO: Meta['tipo'][] = [
  'valor_vendido',
  'comissao_necessaria',
  'faturamento_total',
]

export function ehMetaEmDinheiro(tipo: Meta['tipo']): boolean {
  return TIPOS_EM_DINHEIRO.includes(tipo)
}

// O numero da meta como ela deve aparecer NA TELA, em portugues.
//
// Nasceu de duas copias: o Painel tinha um `formatarPorTipo` que fazia
// String(valor) -- e mostrava "6.3999999999999995" e "80.78%" -- e a tela de
// Metas tinha um `numero()` que formatava bonito mas nao sabia distinguir
// dinheiro de contagem, escrevendo "12.500" onde o Painel escrevia
// "R$ 12.500,00" para a MESMA meta.
export function formatarValorDeMeta(tipo: Meta['tipo'], valor: number): string {
  if (ehMetaEmDinheiro(tipo)) return formatarMoeda(valor)
  // maximumFractionDigits: 2 e o que segura a dizima do ponto flutuante. Sem
  // ele, `6,1 + 0,3` chega inteiro na tela do celular.
  const numero = valor.toLocaleString('pt-BR', { maximumFractionDigits: 2 })
  return tipo === 'cobertura_linhas' ? `${numero}%` : numero
}
